import { localizeWithPath } from 'vscode/vscode/vs/nls';

const _moduleId = "vs/workbench/contrib/welcomeViews/common/viewsWelcomeExtensionPoint";
var ViewsWelcomeExtensionPointFields;
( ((function(ViewsWelcomeExtensionPointFields) {
    ViewsWelcomeExtensionPointFields["view"] = "view";
    ViewsWelcomeExtensionPointFields["contents"] = "contents";
    ViewsWelcomeExtensionPointFields["when"] = "when";
    ViewsWelcomeExtensionPointFields["group"] = "group";
    ViewsWelcomeExtensionPointFields["enablement"] = "enablement";
})(
    ViewsWelcomeExtensionPointFields || (ViewsWelcomeExtensionPointFields = {})
)));
const ViewIdentifierMap = {
    'explorer': 'workbench.explorer.emptyView',
    'debug': 'workbench.debug.welcome',
    'scm': 'workbench.scm',
    'testing': 'workbench.view.testing'
};
const viewsWelcomeExtensionPointSchema = ( (Object.freeze({
    type: 'array',
    description: ( localizeWithPath(
        _moduleId,
        0,
        "Contributed views welcome content. Welcome content will be rendered in tree based views whenever they have no meaningful content to display, ie. the File Explorer when no folder is open. Such content is useful as in-product documentation to drive users to use certain features before they are available. A good example would be a `Clone Repository` button in the File Explorer welcome view."
    )),
    items: {
        type: 'object',
        description: ( localizeWithPath(_moduleId, 1, "Contributed welcome content for a specific view.")),
        required: [
            ViewsWelcomeExtensionPointFields.view,
            ViewsWelcomeExtensionPointFields.contents
        ],
        properties: {
            [ViewsWelcomeExtensionPointFields.view]: {
                anyOf: [
                    {
                        type: 'string',
                        description: ( localizeWithPath(
                            _moduleId,
                            2,
                            "Target view identifier for this welcome content. Only tree based views are supported."
                        ))
                    },
                    {
                        type: 'string',
                        description: ( localizeWithPath(
                            _moduleId,
                            2,
                            "Target view identifier for this welcome content. Only tree based views are supported."
                        )),
                        enum: ( (Object.keys(ViewIdentifierMap)))
                    }
                ]
            },
            [ViewsWelcomeExtensionPointFields.contents]: {
                type: 'string',
                description: ( localizeWithPath(
                    _moduleId,
                    3,
                    "Welcome content to be displayed. The format of the contents is a subset of Markdown, with support for links only."
                )),
            },
            [ViewsWelcomeExtensionPointFields.when]: {
                type: 'string',
                description: ( localizeWithPath(_moduleId, 4, "Condition when the welcome content should be displayed.")),
            },
            [ViewsWelcomeExtensionPointFields.group]: {
                type: 'string',
                description: ( localizeWithPath(_moduleId, 5, "Group to which this welcome content belongs. Proposed API.")),
            },
            [ViewsWelcomeExtensionPointFields.enablement]: {
                type: 'string',
                description: ( localizeWithPath(
                    _moduleId,
                    6,
                    "Condition when the welcome content buttons and command links should be enabled."
                )),
            },
        }
    }
})));
const viewsWelcomeExtensionPointDescriptor = {
    extensionPoint: 'viewsWelcome',
    jsonSchema: viewsWelcomeExtensionPointSchema
};

export { ViewIdentifierMap, ViewsWelcomeExtensionPointFields, viewsWelcomeExtensionPointDescriptor };
